module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_23.867092c9.pdf";